<template>
  <div class="has-fixed-page-subheader">
    <div class="page-subheader  d-flex">
      <div class="page-subheader-content d-flex text-center align-self-center">
        <span class="  text-center align-self-center">
          Submitted Orange Reports
        </span>
        <router-link
          :to="`/dashboard`"
          class="back-to-dashboard-link   text-center align-self-center"
        >
          Back to Dashboard
        </router-link>
      </div>
    </div>

    <v-card elevation="0">
      <!-- <v-card-title
        class="orange-bg font-weight-bold white--text border-top-white page-subheader"
      >
        <div class="page-subheader-content">
          Pending Orange Reports
          <v-divider
            vertical
            thickness="2"
            class="border-opacity-100 mx-3"
            color="white"
          ></v-divider>
          <router-link :to="`/dashboard`" class="back-to-dashboard-link">
            Back to Dashboard
          </router-link>
        </div>
      </v-card-title> -->

      <v-card-text>
        <v-progress-linear
          :active="orangeReportsLoading"
          :indeterminate="orangeReportsLoading"
          absolute
          bottom
        ></v-progress-linear>
        <div
          class="d-flex align-items-center justify-content-start flex-wrap flex-sm-nowrap mx-n6"
        >
          <div class="d-flex align-items-center flex-wrap mr-1 ml-6">
            <v-select
              v-if="isSuperAdmin"
              class="mx-4"
              v-model="viewByRegion"
              :items="viewByRegionItems"
              :loading="isViewByRegionItemsLoading"
              item-text="name"
              item-value="value"
              label="All Regions"
              solo
              bg-color="white"
              density="compact"
              hide-details="true"
              @change="onRegionChanged"
            >
            </v-select>
            <v-select
              v-if="isRegionalManager || isDistrictManger || isSuperAdmin"
              class="mx-4"
              v-model="viewByBranch"
              :items="viewByBranchItems"
              :loading="isViewByBranchItemsLoading"
              item-text="name"
              item-value="value"
              label="All Branches"
              solo
              bg-color="white"
              density="compact"
              hide-details="true"
              @change="onBranchChanged"
            >
            </v-select>
            <v-select
              v-if="
                isBranchManager ||
                  isRegionalManager ||
                  isDistrictManger ||
                  isSuperAdmin
              "
              class="mx-4"
              v-model="viewByAccountManager"
              :items="viewByAccountManagerItems"
              :loading="isViewByAccountManagerItemsLoading"
              item-text="name"
              item-value="value"
              label="All Account Managers"
              solo
              bg-color="white"
              density="compact"
              hide-details="true"
              @change="onAccountManagerChanged"
            >
            </v-select>
          </div>
        </div>
        <div v-if="!orangeReportsLoading" class="mt-3">
          <!-- Start Recent Orange Reports section -->
          <v-row v-if="sortedOrangeReports.length > 0">
            <v-col
              md="2"
              sm="3"
              cols="4"
              v-for="(item, i) in sortedOrangeReports"
              :key="'o' + i"
            >
              <div>
                <p>{{ item.communityName }}</p>
                <p>
                  {{ item.title }}
                  <br />
                  <router-link
                    class="green--text"
                    :to="
                      `/customers/${item.communityId}/orange-reports/${item.id}/edit`
                    "
                  >
                    Edit
                    <!-- {{
                      permissions.orangeReport.canApprove
                        ? "Edit / Approve "
                        : "Edit "
                    }}
                    Orange Report -->
                  </router-link>
                </p>
                <router-link
                  class="green--text"
                  :to="
                    `/customers/${item.communityId}/orange-reports/${item.id}/edit`
                  "
                >
                  <v-img
                    height="200"
                    width="300"
                    :src="reportPicture(item)"
                  ></v-img>
                </router-link>
              </div>
            </v-col>
          </v-row>
          <v-row v-else>
            <v-col class="text-center">
              <div class="text-subtitle-1 text-center">
                No Orange Reports submitted last 90 days
              </div>
            </v-col>
          </v-row>
        </div>
        <!-- End Recent Orange Reports section -->
      </v-card-text>
    </v-card>
    <!-- </v-container> -->
  </div>
</template>

<script>
import {
  GET_QUERY,
  API_ORANGE_REPORTS,
  GET_PAGED,
  API_CUSTOMERS
} from "@/core/store/crud.module";
// import { SET_BREADCRUMB } from "@/core/store/breadcrumbs.module";
// import { API_USERS } from "@/core/store/crud.module";
import dateFormatter from "@/core/helpers/dateFormatter";
import stringFormatter from "@/core/helpers/stringFormatter";
import { validationMixin } from "vuelidate";
// import dataModels from "@/core/helpers/datamodels.js";
// import { required } from "vuelidate/lib/validators";
// import moment from "moment";
import permissionsHelper from "@/core/helpers/permissionsHelper";
import Mgr from "@/core/services/security.service";

export default {
  mixins: [validationMixin],
  components: {},
  data: () => ({
    mgr: new Mgr(),
    userInfo: null,
    options: {
      page: 1,
      itemsPerPage: 5
    },
    pageText: "",
    startingAfter: "",
    endingBefore: "",
    previousPage: 1,
    hasMore: false,
    isLoading: false,
    loading: false,
    snackbarContent: "",
    snackbarColor: "#F06835",
    breadcrumbs: [],
    orangeReports: [],
    sortedOrangeReports: [],
    permissions: {},
    orangeReportsLoading: false,

    viewByRegion: "all",
    viewByRegionItems: [{ name: "All Regions", value: "all" }],
    isViewByRegionItemsLoading: false,
    viewByBranch: "all",
    viewByBranchItems: [{ name: "All Branches", value: "all" }],
    isViewByBranchItemsLoading: false,
    viewByAccountManager: "all",
    viewByAccountManagerItems: [{ name: "All Account Managers", value: "all" }],
    isViewByAccountManagerItemsLoading: false
  }),
  props: {},
  validations() {
    return true;
    // return {
    //   billingInfo: {
    //     subscription: {
    //       nextBillingDates: {
    //         required,
    //         minDate: value =>
    //           dateFormatter.convertToMilliseconds(value) >
    //           dateFormatter.convertToMilliseconds(new Date())
    //       }
    //     }
    //   }
    // };
  },
  watch: {
    // options: async function() {
    //   this.isLoading = true;
    //   if (this.previousPage < this.options.page && this.options.page !== 1) {
    //     this.setStartingAfter();
    //   } else if (
    //     this.previousPage > this.options.page &&
    //     this.options.page !== 1
    //   ) {
    //     this.setEndingBefore();
    //   } else {
    //     this.startingAfter = "";
    //     this.endingBefore = "";
    //   }
    //   this.isLoading = false;
    // }
  },
  async mounted() {
    this.userInfo = await this.mgr.getUser();

    if (this.isSuperAdmin) {
      await this.getRegions();
      await this.getBranches();
      await this.getAccountManagers();
    } else if (this.isRegionalManager || this.isDistrictManger) {
      await this.getBranches();
      await this.getAccountManagers();
    } else if (this.isBranchManager) {
      await this.getAccountManagers();
    }

    this.getRecentOrangeReports();
  },
  async created() {
    if (this.$route.query?.region) this.viewByRegion = this.$route.query.region;

    if (this.$route.query?.branch) this.viewByBranch = this.$route.query.branch;

    if (this.$route.query?.accountManager)
      this.viewByAccountManager = this.$route.query.accountManager;
    // let self = this;
    // self.loading = true;
    // Promise.all([

    //   // await this.getRecipients()
    // ]).then(function() {
    //   self.loading = false;
    // });
    // this.createBreadcrumb();
    this.permissions = await permissionsHelper.getPermissions(); //.then(this.getPermissions);
  },
  methods: {
    async onRegionChanged() {
      this.getRecentOrangeReports();

      if (this.isSuperAdmin) {
        await this.getBranches();
        await this.getAccountManagers();
      }
    },

    async onBranchChanged() {
      this.getRecentOrangeReports();

      if (this.isSuperAdmin) {
        await this.getAccountManagers();
      } else if (this.isRegionalManager) {
        await this.getAccountManagers();
      }
    },
    async onAccountManagerChanged() {
      this.getRecentOrangeReports();
    },
    async getRegions() {
      this.isViewByRegionItemsLoading = true;
      let self = this;

      this.$store
        .dispatch(GET_PAGED, { listName: API_CUSTOMERS + "/regions" })
        .then(response => {
          if (response.status >= 200 || response.status <= 204) {
            let regions = response.data.$values;
            self.viewByRegionItems = [{ name: "All Regions", value: "all" }];
            regions.forEach(el => {
              if (
                self.viewByRegionItems.indexOf(region => region.name == el) < 0
              ) {
                self.viewByRegionItems.push({
                  name: el,
                  value: el
                });
              }
            });
          }
          self.isViewByRegionItemsLoading = false;
        });
    },
    async getBranches() {
      this.isViewByBranchItemsLoading = true;
      let self = this;

      this.$store
        .dispatch(GET_PAGED, {
          listName: API_CUSTOMERS + "/branches",
          params: {
            region: self.viewByRegion
          }
        })
        .then(response => {
          if (response.status >= 200 || response.status <= 204) {
            let branches = response.data.$values;
            self.viewByBranchItems = [{ name: "All Branches", value: "all" }];
            branches.forEach(el => {
              if (
                self.viewByBranchItems.indexOf(branch => branch.name == el) < 0
              ) {
                self.viewByBranchItems.push({
                  name: el,
                  value: el
                });
              }
            });
          }
          self.isViewByBranchItemsLoading = false;
        });
    },
    async getAccountManagers() {
      this.isViewByAccountManagerItemsLoading = true;
      let self = this;

      this.$store
        .dispatch(GET_PAGED, {
          listName: API_CUSTOMERS + "/accountManagers",
          params: {
            region: self.viewByRegion,
            branch: self.viewByBranch
          }
        })
        .then(response => {
          if (response.status >= 200 || response.status <= 204) {
            let items = response.data.$values;
            self.viewByAccountManagerItems = [
              { name: "All Account Managers", value: "all" }
            ];
            items.forEach(el => {
              if (
                self.viewByAccountManagerItems.indexOf(
                  manager => manager.name == el
                ) < 0
              ) {
                self.viewByAccountManagerItems.push({
                  name: el,
                  value: el
                });
              }
            });
          }
          self.isViewByAccountManagerItemsLoading = false;
        });
    },
    async getRecentOrangeReports() {
      this.orangeReportsLoading = true;
      let reportsUrl = `${API_ORANGE_REPORTS}/forUser/0/last90Days?region=${this.viewByRegion}&branch=${this.viewByBranch}&accountManager=${this.viewByAccountManager}`;
      await this.$store
        .dispatch(GET_QUERY, {
          listName: reportsUrl
        })
        .then(response => {
          if (response.status >= 200 || response.status <= 204) {
            this.orangeReports = response.data.$values;

            this.sortedOrangeReports = this.getSortedOrangeReports();
          } else {
            this.$snackbar.showMessage({
              content: response.data || "Something went wrong!",
              color: "red"
            });
          }

          this.orangeReportsLoading = false;
        });
    },
    getSortedOrangeReports() {
      let items = [];
      // if (!this.orangeReports || this.orangeReports.length === 0) return items;
      //.slice();
      items = this.orangeReports; //.filter(el => !el.isApproved);
      // for (let i = 0; i < this.orangeReports.length; i++) {
      //   if (!this.orangeReports[i].isApproved)
      //     items.push(this.orangeReports[i]);
      // }

      items.sort((a, b) => {
        return new Date(b.serviceDate) - new Date(a.serviceDate);
      });
      return items;
    },
    getPermissions(permissionsObj) {
      this.permissions = permissionsObj;
    },
    formatDate(date) {
      return dateFormatter.formatEditDate(date);
    },
    formatDateUs(date) {
      return dateFormatter.formatDateUs(date);
      // return moment.utc(date).format("MM/DD/YYYY");
    },
    capitalizeFirstLetter(string) {
      return stringFormatter.capitalizeFirstLetter(string);
    },
    reportPicture(report) {
      let defaultPicture =
        "https://cdn.vuetifyjs.com/images/parallax/material2.jpg";
      if (!report) return defaultPicture;

      if (report.photos.$values.length > 0) {
        let imagesToShow = report.photos.$values.filter(i => i.showInReport);
        if (imagesToShow && imagesToShow.length > 0)
          return imagesToShow[0].fileUrl;
        return report.photos.$values[0].fileUrl;
      }

      return defaultPicture;
    }
  },
  computed: {
    isSuperAdmin() {
      return (
        this.userInfo?.profile?.aspireRole.indexOf("System Admin") >= 0 ||
        this.userInfo?.profile?.aspireRole.indexOf("Executive") >= 0
      );
    },
    isRegionalManager() {
      return (
        this.userInfo?.profile?.aspireRole.indexOf("Regional Manager") >= 0
      );
    },
    isBranchManager() {
      return this.userInfo?.profile?.aspireRole.indexOf("Branch Manager") >= 0;
    },
    isDistrictManger() {
      return (
        this.userInfo?.profile?.aspireRole.indexOf("District Manager") >= 0
      );
    }
  }
};
</script>
